import { toast } from 'react-toastify';
import Warning from '../assets/images/WarningOctagon.png'
import { useDispatch } from 'react-redux';
import { DeleteFood } from '../services/foodsServices';
import { fetchFood } from '../redux/slices/foodSlice';
import { useEffect } from 'react';

export default function ConfirmDeleteFood({isOpen, onClose, item}) {
  const dispatch = useDispatch();
  console.log(item?.id)

  useEffect(() =>{
    dispatch(fetchFood())
  }, [dispatch])

  const deleteFn = async () => {
    if (item && item.id) {
      try {
        const res = await DeleteFood(item.id);
        if (res.statusCode === 200) {
          dispatch(fetchFood());
          onClose();
          toast.success(res.message);
        } else if(res?.statusCode === 404){
          toast.error(res.message)
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        console.error("Error deleting foodItem:", error);
        toast.error("Failed to delete FoodItem. Please try again.");
      }
    } else {
      toast.error("Invalid FoodItem data. Unable to delete.");
      console.error("Invalid item:", item);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal fixed inset-0 bg-orange/20 backdrop-blur-[1px] grid place-items-center z-100">
      <div className='bg-white rounded-2xl py-5 px-6 max-w-md'>
        <div className=" flex justify-center rounded-full">
          <img src={Warning} alt="" className='bg-[#eec4c4] rounded-full' />
        </div>
        <div className='mt-5'>
          <h2 className="text-4xl text-primaryRed text-center">Confirm Delete</h2>
          <div>
            <p class="text-center py-4">
              Are you sure you want to Delete this food?
            </p>
          </div>
          <div className='flex items-center justify-center gap-x-6 mt-5'>
            <button className="text-primaryRed border border-[#FFB0B0] px-6 py-2 text-center rounded-md w-full hover:bg-[#FFB0B0]" onClick={onClose}>Cancel</button>
            <button className="text-white border border-primryRed bg-primaryRed px-6 py-2 text-center rounded-md hover:bg-primaryRed/80 w-full"  onClick={deleteFn}>
            Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
